// extracted by mini-css-extract-plugin
export default {"numbers":"EventNumbers_numbers__lmc1-","number":"EventNumbers_number__MjCoW"};